<template>
  <modal
    class="editCreditLimit"
    name="companyDomain"
    transition="pop-out"
    :width="modalWidth"
    :height="400"
  >
    <div class="text-center py-5">
      <h4>{{ $t("text.companyDomain.updateCompanyDomain") }}</h4>
    </div>
    <div class="sign_up_form_section">
      <form>
        <div class="row justify-content-center">
          <div class="col-md-7">
            <div class="price_change_input_wrapper" ref="cd_div">
              <input
                type="text"
                v-model="companyDomain"
                :placeholder="$t('text.companyDomain.title')"
                @blur="captureFormEvents($event)"
              />
            </div>
            <div ref="cdr"></div>
          </div>
        </div>

        <div class="text-center mt-5">
          <button
            class="show_more_button remove_text_decoration"
            @click="updateCompanyDomain($event)"
            :disabled="isButtonDisabled ? true : null"
            :style="[
              isButtonDisabled
                ? { cursor: 'not-allowed' }
                : { cursor: 'pointer' },
            ]"
          >
            {{ $t("text.companyDomain.update") }} <span></span>
          </button>
          <img
            src="@/assets/img/git_loader.gif"
            style="display: none"
            width="35px"
            class="ml-3 loader"
          />
        </div>
      </form>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 656;

export default {
  name: "companyDomain",
  props: [],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      companyDomain: "",
      company: localStorage.getItem("companyDetails")
        ? JSON.parse(localStorage.getItem("companyDetails"))
        : null,
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    validEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },
    captureFormEvents($event) {
      if ($event.target.placeholder === this.$t("text.companyDomain.title")) {
        if ($event.target.value === "") {
          this.$refs.cdr.style.display = "block";
          this.$refs.cdr.innerHTML = this.$t(
            "text.companyDomain.domainMissing"
          );
          this.$refs.cd_div.style.border = "1px solid red";
          this.$refs.cdr.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.cdr.style.display = "none";
          this.$refs.cdr.innerHTML = "";
          this.$refs.cd_div.style.border = "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
    },
    closeCompanyDoaminModal() {
      this.$modal.hide("companyDomain");
    },
    updateCompanyDomain($event) {
      $event.preventDefault();
      if (!this.companyDomain) {
        this.$refs.cdr.style.display = "block";
        this.$refs.cdr.innerHTML = this.$t("text.companyDomain.domainMissing");
        this.$refs.cd_div.style.border = "1px solid red";
        this.$refs.cdr.style.color = "red";
        this.formIsValid = false;
        return;
      } else {
        this.$refs.cdr.style.display = "none";
        this.$refs.cdr.innerHTML = "";
        this.$refs.cd_div.style.border = "1px solid rgb(75, 44, 114)";
        this.formIsValid = true;
        this.isButtonDisabled = true;
        $(".loader").show();

        let data = {
          emailDomain: this.companyDomain,
        };

        this.axios
          .post(
            `${configObject.apiBaseUrl}/Company/UpdateEmailDomain/${this.$route.query.companyId}`,
            data,
            configObject.authConfig()
          )
          .then(() => {
            $(".loader").hide();
            this.isButtonDisabled = false;
            this.closeCompanyDoaminModal();
            this.$toast.open({
              message: this.$t("text.companyDomain.successfullyUpdated"),
              type: "success",
              duration: 5000,
            });
            this.companyDomain = null;
          })
          .catch((error) => {
            this.isButtonDisabled = false;
            $(".loader").hide();
          });
      }
    },
  },
};
</script>
